<div
  class="w-11/12 xl:w-2/3 center bg-[#dedede17] shadow-md rounded-xl"
  [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'"
>
  <p class="text-center font-semibold py-5 text-lg lg:text-xl">
    {{ "areYouInter" | transloco }}
  </p>
  <form *ngIf="contactForm" [formGroup]="contactForm" autocomplete="off">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 px-5">
      <!-- Company Name -->
      <div>
        <label class="flex mb-1 font-semibold text-gray-700">
          {{ "companyName" | transloco }}
          <span class="text-red-600 text-3xl">*</span>
        </label>
        <input
          type="text"
          formControlName="companyName"
          [placeholder]="'EnteryourCompanyName' | transloco"
          class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
        />
        <div *ngIf="formErrors.companyName" class="text-red-500 text-sm mt-1">
          {{ formErrors.companyName }}
        </div>
      </div>

      <!-- Email -->
      <div>
        <label class="flex mb-1 font-semibold text-gray-700">
          {{ "email" | transloco }} <span class="text-red-600 text-3xl">*</span>
        </label>
        <input
          type="email"
          formControlName="email"
          [placeholder]="'enterYourEmail' | transloco"
          class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
        />
        <div *ngIf="formErrors.email" class="text-red-500 text-sm mt-1">
          {{ formErrors.email }}
        </div>
      </div>

      <!-- Country Select (still using mat-select) -->
      <div class="md:col-span-2">
        <label class="block mb-1 font-semibold text-gray-700">
          {{ "country" | transloco }}
        </label>
        <mat-select
          id="country"
          [(ngModel)]="selectedCountryIso"
          [ngModelOptions]="{ standalone: true }"
          name="countryIso"
          panelClass="custom-dropdown-panel"
          class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
        >
          <mat-select-trigger>
            <div class="flex items-center">
              <span
                class="w-6 h-4 mr-2 overflow-hidden"
                [style.backgroundImage]="'url(\'/assets/flags/flags.png\')'"
                [style.backgroundRepeat]="'no-repeat'"
                [style.backgroundPosition]="
                  getCountryByIso(selectedCountryIso)?.flagImagePos
                "
                [style.backgroundSize]="'24px 3876px'"
              ></span>
              <span class="font-medium">
                {{ getCountryByIso(selectedCountryIso)?.code }}
                {{ getCountryByIso(selectedCountryIso)?.name }}
              </span>
            </div>
          </mat-select-trigger>

          <mat-option
            *ngFor="let country of countries; trackBy: trackByFn"
            [value]="country.iso"
            (click)="setCountry(country)"
          >
            <div class="flex items-center">
              <span
                class="w-6 h-4 mr-2 overflow-hidden"
                [style.background]="
                  'url(\'/assets/flags/flags.png\') no-repeat ' +
                  country.flagImagePos
                "
                [style.backgroundSize]="'24px 3876px'"
              ></span>
              <span>{{ country.name }}</span>
              <span class="ml-2 font-medium text-sm">{{ country.code }}</span>
            </div>
          </mat-option>
        </mat-select>
        <div
          *ngIf="
            contactForm.get('prefix')?.invalid &&
            contactForm.get('prefix')?.touched
          "
          class="text-red-500 text-sm mt-1"
        >
          {{ "countryCodeRequired" | transloco }}
        </div>
      </div>

      <!-- Phone Number -->
      <div>
        <label class="flex mb-1 font-semibold text-gray-700">
          {{ "phoneNumber" | transloco }}
          <span class="text-red-600 text-3xl">*</span>
        </label>
        <input
          type="text"
          formControlName="phoneNumber"
          [placeholder]="'phoneNumber' | transloco"
          class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
        />
        <div
          *ngIf="
            contactForm.get('phoneNumber')?.invalid &&
            contactForm.get('phoneNumber')?.touched
          "
          class="text-red-500 text-sm mt-1"
        >
          <span *ngIf="contactForm.get('phoneNumber')?.errors?.required">
            {{ "phoneRequired" | transloco }}
          </span>
          <span *ngIf="contactForm.get('phoneNumber')?.errors?.pattern">
            {{ "phonePatternError" | transloco }}
          </span>
        </div>
      </div>

      <!-- How Reach Us -->
      <div class="w-full">
        <label class="block mb-1 font-semibold text-gray-700">
          {{ "howReachUs" | transloco }}
        </label>
        <div
          class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus-within:ring-2 focus-within:ring-[#A67C52]"
        >
          <mat-select
            formControlName="howReachUs"
            disableOptionCentering
            class="w-full bg-transparent focus:outline-none"
            [panelClass]="'custom-select-panel'"
          >
            <mat-option value="Google">Google</mat-option>
            <mat-option value="Youtube">Youtube</mat-option>
            <mat-option value="Friend">Friend</mat-option>
            <mat-option value="Exhibition">Exhibition</mat-option>
            <mat-option value="Facebook">Facebook</mat-option>
            <mat-option value="Instagram">Instagram</mat-option>
            <mat-option value="X (Twitter)">X (Twitter)</mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <!-- Confirmation message -->
    <div
      *ngIf="viewRecieveMessage"
      class="text-center text-green-500 mt-6 text-lg"
    >
      {{ "messageReceived" | transloco }}
    </div>

    <!-- Submit Button -->
    <div class="py-6 text-center">
      <button
        type="button"
        (click)="onSubmit()"
        [disabled]="contactForm.invalid || isSubmitting || contactForm.pristine"
        class="bg-[#E60027] text-white px-6 py-3 rounded-xl font-semibold tracking-wide hover:bg-[#a7001c] disabled:bg-[#ff798f] transition"
      >
        {{ "sendRequest" | transloco }}
      </button>
    </div>
  </form>
</div>
